import { render, staticRenderFns } from "./collectInfo.vue?vue&type=template&id=28f54fc4&scoped=true"
import script from "./collectInfo.vue?vue&type=script&lang=js"
export * from "./collectInfo.vue?vue&type=script&lang=js"
import style0 from "./collectInfo.vue?vue&type=style&index=0&id=28f54fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f54fc4",
  null
  
)

export default component.exports